import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const OfficePage = () => {
  const columns = [
    { key: 'name', label: 'Office Name' },
    { key: 'address', label: 'Address' },
    { key: 'city', label: 'City' },
    { key: 'state', label: 'State' },
    { key: 'zip', label: 'ZIP' },
    { key: 'phone', label: 'Phone' },
    { key: 'active', label: 'Active' },
  ];

  const initialData = [
    { id: '1', name: 'Main Office', address: '1234 Healthcare Blvd', city: 'Houston', state: 'TX', zip: '77001', phone: '(713) 555-0100', active: 'Yes' },
    { id: '2', name: 'North Branch', address: '5678 Medical Dr', city: 'The Woodlands', state: 'TX', zip: '77380', phone: '(281) 555-0200', active: 'Yes' },
    { id: '3', name: 'South Branch', address: '9012 Care Center Way', city: 'Sugar Land', state: 'TX', zip: '77478', phone: '(281) 555-0300', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Office"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Office"
    />
  );
};

export default OfficePage;
